import React, { useEffect, useState } from "react";
import { getByAgentId } from "../pages/services/agentsCatalogService";

// Cache compartido entre renders e instancias para evitar pegarle al backend
// una vez por celda. La vida del cache es la pestania del navegador.
const agentCache = new Map();
const inFlight = new Map();

const fetchAgent = (businessAgentId) => {
  if (agentCache.has(businessAgentId)) {
    return Promise.resolve(agentCache.get(businessAgentId));
  }
  if (inFlight.has(businessAgentId)) {
    return inFlight.get(businessAgentId);
  }
  const promise = getByAgentId(businessAgentId)
    .then((response) => {
      const agent = response?.data || null;
      if (agent) agentCache.set(businessAgentId, agent);
      inFlight.delete(businessAgentId);
      return agent;
    })
    .catch((error) => {
      inFlight.delete(businessAgentId);
      throw error;
    });
  inFlight.set(businessAgentId, promise);
  return promise;
};

// Parche temporal: backend devuelve currCase.agent resuelto contra la PK del
// catalogo en lugar del business id, por lo que muestra al agente equivocado
// cuando hay colisiones numericas. Re-resolvemos por business id aqui.
// Soporta tres campos: agentId | agentName | promoterEdit.
const AgentCell = ({ businessAgentId, fallback, field = "agentId" }) => {
  const [agent, setAgent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!businessAgentId) {
      setAgent(null);
      return undefined;
    }
    fetchAgent(businessAgentId)
      .then((data) => {
        if (!cancelled) setAgent(data);
      })
      .catch(() => {
        if (!cancelled) setAgent(null);
      });
    return () => {
      cancelled = true;
    };
  }, [businessAgentId]);

  if (agent && agent[field] !== undefined && agent[field] !== null) {
    return <>{agent[field]}</>;
  }
  return <>{fallback ?? ""}</>;
};

export default AgentCell;
